<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 0 24 24" :width="size + 'px'" fill="currentColor">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconChevronRight",
  mixins: [ IconBase ],
  props: { ...IconBase.props,
    size: {
      default: "22"
    }
  }
}
</script>